import script from "./CheckSquare.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckSquare.vue?vue&type=script&setup=true&lang=ts"

import "./CheckSquare.vue?vue&type=style&index=0&id=3ce9953a&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce9953a"]])

export default __exports__